import React, { useState, createContext } from "react";
import campaignData from "./campaignData";

export const CampaignContext = createContext();

export const CampaignContextProvider = (props) => {
    const [data, setData] = useState(campaignData);

    return <CampaignContext.Provider value={{contextData: [data, setData]}}>{props.children}</CampaignContext.Provider>
}